import { Link } from 'react-router-dom';

const Footer = () => {
  const footerNav = [
    { name: 'Legal & Compliance', path: '/legal-compliance' },
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms of Use', path: '/terms-of-use' },
    { name: 'Partner Disclaimer', path: '/partner-disclaimer' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="section-container">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-6">
                <img width={200} src='/assets/mgl_logo.png' alt="Website logo" />
            </div>
            <p className="text-gray-400 mb-4">
              Designing, owning, and scaling destination-led travel experiences through strategic partnerships.
            </p>
            <p className="text-sm text-gray-500">
              UK-based Travel Events, Experiences & Intellectual Property Company (B2B)
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/what-we-do" className="text-gray-400 hover:text-primary transition-colors">
                  What We Do
                </Link>
              </li>
              <li>
                <Link to="/experiences" className="text-gray-400 hover:text-primary transition-colors">
                  Our Experiences
                </Link>
              </li>
              <li>
                <Link to="/partners-sponsors" className="text-gray-400 hover:text-primary transition-colors">
                  Partnerships
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Legal</h4>
            <ul className="space-y-3">
              {footerNav.map((item) => (
                <li key={item.name}>
                  <Link to={item.path} className="text-gray-400 hover:text-primary transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Connect</h4>
            <p className="text-gray-400 mb-4">
              For partnership enquiries and strategic collaborations.
            </p>
            <Link
              to="/contact"
              className="inline-block btn-primary"
            >
              Start a Conversation
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500">
          <p className="mb-2">© {new Date().getFullYear()} MGL Experiences Ltd. All rights reserved.</p>
          <p className="text-sm">
            Formerly MGL Travels. A UK-based travel events and experiences company.
          </p>
          <p className="text-sm mt-2">
            This website is for B2B partnerships only. Not for consumer travel bookings.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;